module.exports = __webpack_public_path__ + "static/media/co.9f35d8a7.png";